import { Button, styled } from '@mui/material';

export const Title = styled('p')(({ theme }) => ({
  margin: 0,
  color: theme.palette.secondary.dark,
  fontSize: '1.125rem',
  fontStyle: 'normal',
  fontWeight: 600,
  lineHeight: '120%',
}));

export const DownloadAllButton = styled(Button)(({ theme }) => ({
  backgroundColor: theme.palette.purple[600],

  '&:hover': {
    backgroundColor: theme.palette.purple[500],
  },
  '&:active': {
    backgroundColor: theme.palette.purple[400],
  },
}));

export const PlaceholderContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  width: '5rem',
  height: '5rem',
  padding: '1.75rem',
  justifyContent: 'center',
  alignItems: 'center',
  borderRadius: '0.25rem',
  backgroundColor: theme.palette.grey[50],
}));

export const FileDetails = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.75rem;
`;

export const FileName = styled('p')(({ theme }) => ({
  margin: 0,
  fontSize: '0.625rem',
  fontStyle: 'normal',
  fontWeight: 400,
  lineHeight: '160%',
  color: theme.palette.grey[700],
  overflowWrap: 'break-word',
  width: '10rem',
}));
